<template>
  <g>
    <g v-for="(child, i) in node.children" :key="child.id">
      <path :d="path(i)" stroke="#fff" stroke-width="0.6" fill="none" />

      <TreeNode :node="child" :x="childX(i)" :y="y + GAP_Y" :parent="node" />
    </g>

    <circle :cx="x" :cy="y" :r="RADIUS" :fill="circleColor" />
  </g>
</template>

<script>
export default {
  name: "TreeNode",
  props: {
    node: {
      type: Object,
      required: true,
    },
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    parent: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth < 480;
    },
    GAP_X() {
      return this.isMobile ? 18 : 28;
    },
    GAP_Y() {
      return this.isMobile ? 26 : 36;
    },
    RADIUS() {
      return this.isMobile ? 4 : 5;
    },

    circleColor() {
      if (
        this.node.type === "choice" &&
        this.node.isLeaf === true &&
        this.parent?.isQuestion === true
      ) {
        return "#E53935";
      }

      return "#FFFFFF";
    },
  },
  methods: {
    childX(i) {
      const count = this.node.children.length;
      return this.x + (count === 1 ? 0 : (i - (count - 1) / 2) * this.GAP_X);
    },
    path(i) {
      const cx = this.childX(i);
      const cy = this.y + this.GAP_Y;
      return `M ${this.x} ${this.y + this.RADIUS} L ${cx} ${cy - this.RADIUS}`;
    },
  },
};
</script>
